import React from "react";
import './LoadingBar.css';


interface LoadingBarProps {
    color?: string;
    progress: number;
}
const LoadingBar: React.FC<LoadingBarProps> = ({ color='#4bd5bc', progress=0}) => {
    const barStyle: React.CSSProperties = {
        width: `${progress}%`,
        backgroundColor: color
    };
    return (
        <div className="loading-bar">
            <div className="bar" style={barStyle}></div>
            <div className="percentage">{progress}%</div>
        </div>
    );
};

export default LoadingBar;